import React, {useState, useEffect} from 'react'
import { useHistory } from "react-router-dom"
import {Table,Button} from "react-bootstrap"
import "./growth.css"
import Header from "./Header"
import {Icon} from "@iconify/react"
import babyIcon from '@iconify-icons/fa-solid/baby';// npm install --save-dev @iconify/react @iconify-icons/openmoji
import iNeurology from '@iconify-icons/medical-icon/i-neurology';
import scaleUnbalance from '@iconify-icons/vaadin/scale-unbalance';
import homeIcon from '@iconify-icons/fa-solid/home';
import { std } from 'mathjs' //standard deviation unbiased?
import {icdf,cdf} from "norm-dist"
import pdf from "norm-dist/pdf"

//css bubble colors
import WhiteW from "./WhiteW"
import GreenW from "./GreenW"
import OrangeW from "./OrangeW"
import RedW from "./RedW"

import WhiteHC from "./WhiteHC"
import GreenHC from "./GreenHC"
import OrangeHC from "./OrangeHC"
import RedHC from "./RedHC"

//indicator



function Scores() {
    let history = useHistory();
    //window.location.replace("/z-score")// refresh to debug "changes" circle?
    
    const home = () => {
        history.push("/");  
        localStorage.clear()
    }

    /**
     * FROM TABLE value
     */

     //for z-score weight 
     var weight1 = localStorage.getItem("weight 1")   

     var weight2 = localStorage.getItem("weight 2")   

     var weight3 = localStorage.getItem("weight 3")   

     var weight4 = localStorage.getItem("weight 4")   

     var weight5 = localStorage.getItem("weight 5")   

     var weight6 = localStorage.getItem("weight 6")   

     var weight7 = localStorage.getItem("weight 7")   

     var weight8 = localStorage.getItem("weight 8")   


     //for z-score length
     var length1 = localStorage.getItem("length 1")   

     var length2 = localStorage.getItem("length 2")   

     var length3 = localStorage.getItem("length 3")   

     var length4 = localStorage.getItem("length 4")   

     var length5 = localStorage.getItem("length 5")   

     var length6 = localStorage.getItem("length 6")   

     var length7 = localStorage.getItem("length 7")   

     var length8 = localStorage.getItem("length 8")   


     //for z-score hc
     var hc1 = localStorage.getItem("hc 1")   

     var hc2 = localStorage.getItem("hc 2")   

     var hc3 = localStorage.getItem("hc 3")   

     var hc4 = localStorage.getItem("hc 4")   

     var hc5 = localStorage.getItem("hc 5")   

     var hc6 = localStorage.getItem("hc 6")   

     var hc7 = localStorage.getItem("hc 7")   

     var hc8 = localStorage.getItem("hc 8")   

    //getting zscore json (Girl Weight Ref)
    const [dataGW,setDataGW]=useState([]);

    

    async function getGWR (){
       
        await fetch('zscore/testGWZ.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }
      }
      )
        .then(function(response){
          return response.json();
        })
        .then(function(myJson) {
          //console.log(myJson,"myJson");
          setDataGW(myJson)
        });

    }

    //getting zscore json (Girl Length Ref)
        const [dataGL,setDataGL]=useState([]);
        async function getGLR() {
           await fetch('zscore/testGLZ.json'
          ,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }
          }
          )
            .then(function(response){
              return response.json();
            })
            .then(function(myJson) {
              //console.log(myJson,"myJson");
              setDataGL(myJson)
            });
    
        }

    //getting zscore json (Girl Head Ref)
    
        const [dataGH,setDataGH]=useState([]);
        async function getGHR(){
            await fetch('zscore/testGHZ.json'
          ,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }
          }
          )
            .then( function(response){
              return  response.json();
            })
            .then(function(myJson) {
              //console.log(myJson,"myJson");
              setDataGH(myJson)
            });
    
        }


    //getting zscore json (Boy Weight Ref)
    const [dataBW,setDataBW]=useState([]);
    async function getBWR(){
       await fetch('zscore/testBWZ.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }
      }
      )
        .then(function(response){
          return response.json();
        })
        .then(function(myJson) {
          //console.log(myJson,"myJson");
          setDataBW(myJson)
        });

    }

    //getting zscore json (Boy Length Ref)
    const [dataBL,setDataBL]=useState([]);
    async function getBLR(){
       await fetch('zscore/testBLZ.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }
      }
      )
        .then(function(response){
          return response.json();
        })
        .then(function(myJson) {
          //console.log(myJson,"myJson");
          setDataBL(myJson)
        });

    }

    //getting zscore json (Boy Head Ref)
    const [dataBH,setDataBH]=useState([]);
    async function getBHR(){
       await fetch('zscore/testBHZ.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }
      }
      )
        .then(function(response){
          return response.json();
        })
        .then(function(myJson) {
          //console.log(myJson,"myJson");
          setDataBH(myJson)
        });

    }



     //from Weight @ Table
     var bweight1 = weight1 * 1000 //kg to g
     var bweight2 = weight2 * 1000 //kg to g
     var bweight3 = weight3 * 1000 //kg to g
     var bweight4 = weight4 * 1000 //kg to g
     var bweight5 = weight5 * 1000 //kg to g
     var bweight6 = weight6 * 1000 //kg to g
     var bweight7 = weight7 * 1000 //kg to g
     var bweight8 = weight8 * 1000 //kg to g

     //from Length @ Table
     var blength1 = length1
     var blength2 = length2
     var blength3 = length3
     var blength4 = length4
     var blength5 = length5
     var blength6 = length6
     var blength7 = length7
     var blength8 = length8

     //from Head @ Table 
     var bhead1 = hc1
     var bhead2 = hc2
     var bhead3 = hc3
     var bhead4 = hc4
     var bhead5 = hc5
     var bhead6 = hc6
     var bhead7 = hc7
     var bhead8 = hc8


     
     var postweek1 = localStorage.getItem("Post week 1")
     var postday1 = localStorage.getItem("Post day 1")
     var gender = localStorage.getItem("gender")
     var ageDetail1 = ((postweek1 - 22) * 7) + +postday1
     localStorage.setItem("ageDetail1", ageDetail1)

     var postweek2 = localStorage.getItem("Post week 2")
     var postday2 = localStorage.getItem("Post day 2")
     var ageDetail2 = ((postweek2 - 22) * 7) + +postday2
     localStorage.setItem("ageDetail2", ageDetail2)


     var postweek3 = localStorage.getItem("Post week 3")
     var postday3 = localStorage.getItem("Post day 3")
     var ageDetail3 = ((postweek3 - 22) * 7) + +postday3
     localStorage.setItem("ageDetail3", ageDetail3)


     var postweek4 = localStorage.getItem("Post week 4")
     var postday4 = localStorage.getItem("Post day 4")
     var ageDetail4 = ((postweek4 - 22) * 7) + +postday4
     localStorage.setItem("ageDetail4", ageDetail4)


     var postweek5 = localStorage.getItem("Post week 5")
     var postday5 = localStorage.getItem("Post day 5")
     var ageDetail5 = ((postweek5 - 22) * 7) + +postday5
     localStorage.setItem("ageDetail5", ageDetail5)


     var postweek6 = localStorage.getItem("Post week 6")
     var postday6 = localStorage.getItem("Post day 6")
     var ageDetail6 = ((postweek6 - 22) * 7) + +postday6
     localStorage.setItem("ageDetail6", ageDetail6)


     var postweek7 = localStorage.getItem("Post week 7")
     var postday7 = localStorage.getItem("Post day 7")
     var ageDetail7 = ((postweek7 - 22) * 7) + +postday7
     localStorage.setItem("ageDetail7", ageDetail7)


     var postweek8 = localStorage.getItem("Post week 8")
     var postday8 = localStorage.getItem("Post day 8")
     var ageDetail8 = ((postweek8 - 22) * 7) + +postday8
     localStorage.setItem("ageDetail8", ageDetail8)

     

    //For Girl Weight    
    if(dataGW && dataGW.length > 0 ){
        dataGW.map((item) => {
            for (let i =0; i < dataGW.length; i++) {
            var items = dataGW
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="girl"){ // GIRL
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 3.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        
                        var gzweight1 = (((bweight1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                        if(bweight1 > 0) {
                            localStorage.setItem("gzweight1" , gzweight1)
                        }

                        
                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight2 = (((bweight2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight2 > 0) {
                            localStorage.setItem("gzweight2" , gzweight2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight3 = (((bweight3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight3 > 0) {
                            localStorage.setItem("gzweight3" , gzweight3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight4 = (((bweight4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight4 > 0) {
                            localStorage.setItem("gzweight4" , gzweight4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight5 = (((bweight5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight5 > 0) {
                            localStorage.setItem("gzweight5" , gzweight5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight6 = (((bweight6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight6 > 0) {
                            localStorage.setItem("gzweight6" , gzweight6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight7 = (((bweight7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight7 > 0) {
                            localStorage.setItem("gzweight7" , gzweight7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight8 = (((bweight8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight8 > 0) {
                            localStorage.setItem("gzweight8" , gzweight8)
                        }
                    }
                }
            }
        }

    })}

    //for girl length!
    if(dataGL && dataGL.length > 0 ){
        dataGL.map((item) => {
            for (let i =0; i < dataGL.length; i++) {
            var items = dataGL
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="girl"){ // GIRL
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 10.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196 ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        
                        var gzlength1 = (((blength1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                        if(blength1 > 0) {
                            localStorage.setItem("gzlength1" , gzlength1)
                        }

                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 10.5 ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength2 = (((blength2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength2 > 0) {
                            localStorage.setItem("gzlength2" , gzlength2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength3 = (((blength3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength3 > 0) {
                            localStorage.setItem("gzlength3" , gzlength3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength4 = (((blength4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength4 > 0) {
                            localStorage.setItem("gzlength4" , gzlength4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength5 = (((blength5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength5 > 0) {
                            localStorage.setItem("gzlength5" , gzlength5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength6 = (((blength6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength6 > 0) {
                            localStorage.setItem("gzlength6" , gzlength6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength7 = (((blength7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength7 > 0) {
                            localStorage.setItem("gzlength7" , gzlength7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength8 = (((blength8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength8 > 0) {
                            localStorage.setItem("gzlength8" , gzlength8)
                        }
                    }
                }
            }
        }

            
    })}

    //for girl head!
    if(dataGH && dataGH.length > 0 ){
        dataGH.map((item) => {
            for (let i =0; i < dataGH.length; i++) {
            var items = dataGH
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="girl"){ // GIRL
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 10.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        
                        var ghead1 = (((bhead1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                        if(bhead1 > 0) {
                            localStorage.setItem("ghead1" , ghead1)
                        }

                        
                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead2 = (((bhead2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead2 > 0) {
                            localStorage.setItem("ghead2" , ghead2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 >196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead3 = (((bhead3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead3 > 0) {
                            localStorage.setItem("ghead3" , ghead3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead4 = (((bhead4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead4 > 0) {
                            localStorage.setItem("ghead4" , ghead4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead5 = (((bhead5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead5 > 0) {
                            localStorage.setItem("ghead5" , ghead5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead6 = (((bhead6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead6 > 0) {
                            localStorage.setItem("ghead6" , ghead6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead7 = (((bhead7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead7 > 0) {
                            localStorage.setItem("ghead7" , ghead7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead8 = (((bhead8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead8 > 0) {
                            localStorage.setItem("ghead8" , ghead8)
                        }
                    }
                }
            }
        }
            
    })}


    //for boy weight!
    if(dataBW && dataBW.length > 0 ){
        dataBW.map((item) => {
            for (let i =0; i < dataBW.length; i++) {
            var items = dataBW
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="boy"){ // BOY
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 3.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight1 = (((bweight1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                        if(bweight1 > 0) {

                            localStorage.setItem("gzweight1" , gzweight1)
                        }

                        
                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight2 = (((bweight2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight2 > 0) {
                            localStorage.setItem("gzweight2" , gzweight2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight3 = (((bweight3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight3 > 0) {
                            localStorage.setItem("gzweight3" , gzweight3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight4 = (((bweight4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight4 > 0) {
                            localStorage.setItem("gzweight4" , gzweight4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196 ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight5 = (((bweight5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight5 > 0) {
                            localStorage.setItem("gzweight5" , gzweight5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight6 = (((bweight6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight6 > 0) {
                            localStorage.setItem("gzweight6" , gzweight6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 3.5 ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight7 = (((bweight7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight7 > 0) {
                            localStorage.setItem("gzweight7" , gzweight7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 3.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzweight8 = (((bweight8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bweight8 > 0) {
                            localStorage.setItem("gzweight8" , gzweight8)
                        }
                    }
                }
            }
        }

            
        })
    }

    //for Boy length
    if(dataBL && dataBL.length > 0 ){
        dataBL.map((item) => {
            for (let i =0; i < dataBL.length; i++) {
            var items = dataBL
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="boy"){ // BOY
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 10.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength1 = (((blength1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S)) //S value @ age 196 = 0 causes infinity
                        
                        if(blength1 > 0) {
                            localStorage.setItem("gzlength1" , gzlength1)
                        }

                        
                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength2 = (((blength2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength2 > 0) {
                            localStorage.setItem("gzlength2" , gzlength2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength3 = (((blength3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength3 > 0) {
                            localStorage.setItem("gzlength3" , gzlength3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 10.5 ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength4 = (((blength4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength4 > 0) {
                            localStorage.setItem("gzlength4" , gzlength4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength5 = (((blength5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength5 > 0) {
                            localStorage.setItem("gzlength5" , gzlength5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196 ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength6 = (((blength6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength6 > 0) {
                            localStorage.setItem("gzlength6" , gzlength6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 10.5 ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength7 = (((blength7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength7 > 0) {
                            localStorage.setItem("gzlength7" , gzlength7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196 ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var gzlength8 = (((blength8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(blength8 > 0) {
                            localStorage.setItem("gzlength8" , gzlength8)
                        }
                    }
                }
            }
        }

    })}

    //for Boy head
    if(dataBH && dataBH.length > 0 ){
        dataBH.map((item) => {
            for (let i =0; i < dataBH.length; i++) {
            var items = dataBH
            var gageDet = items[i].ageD //iterate through ageD in json => sanity check
            
            if(gender=="boy"){ // BOY
                if ( ageDetail1 == gageDet ){ //ageDetail in json available
                    if ( ageDetail1 < 10.5  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail1 > 196  ){
                        //do nothing
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead1 = (((bhead1 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                        if(bhead1 > 0) {
                            localStorage.setItem("ghead1" , ghead1)
                        }

                        
                    }
                }

                else if(ageDetail2 == gageDet){

                    if ( ageDetail2 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail2 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead2 = (((bhead2 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead2 > 0) {
                            localStorage.setItem("ghead2" , ghead2)
                        }
                    }
                }
            
                else if(ageDetail3 == gageDet){

                    if ( ageDetail3 < 10.5 ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail3 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead3 = (((bhead3 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead3 > 0) {
                            localStorage.setItem("ghead3" , ghead3)
                        }
                    }
                }

                else if(ageDetail4 == gageDet){

                    if ( ageDetail4 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail4 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead4 = (((bhead4 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead4 > 0) {
                            localStorage.setItem("ghead4" , ghead4)
                        }
                    }
                }

                else if(ageDetail5 == gageDet){

                    if ( ageDetail5 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail5 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead5 = (((bhead5 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead5 > 0) {
                            localStorage.setItem("ghead5" , ghead5)
                        }
                    }
                }

                else if(ageDetail6 == gageDet){

                    if ( ageDetail6 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail6 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead6 = (((bhead6 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead6 > 0) {
                            localStorage.setItem("ghead6" , ghead6)
                        }
                    }
                }

                else if(ageDetail7 == gageDet){

                    if ( ageDetail7 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail7 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead7 = (((bhead7 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead7 > 0) {
                            localStorage.setItem("ghead7" , ghead7)
                        }
                    }
                }
                else if(ageDetail8 == gageDet){

                    if ( ageDetail8 < 10.5  ){
                        console.log("NO Z")
                        
                    }

                    else if ( ageDetail8 > 196  ){
                        console.log("NO Z")
                        
                    }
                    else {
                        var ghead8 = (((bhead8 / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L*items[i].fields.S))
                    
                        if(bhead8 > 0) {
                            localStorage.setItem("ghead8" , ghead8)
                        }
                    }
                }
            }
        }

            
    })}
    
    
    //false ==> red => Weight
    const [isBackgroundRed, setisBackgroundRed] = useState(false);
    //false  ==> green => HC
    const [isBackgroundGreen, setisBackgroundGreen] = useState(false);

    //weight
    const [green, setGreen] = useState(false);
    const [orange, setOrange] = useState(false);
    const [red, setRed] = useState(false);
    const [white,setWhite] = useState(false);
        //hc color
    const [greenhc, setGreenhc] = useState(false);
    const [orangehc, setOrangehc] = useState(false);
    const [redhc, setRedhc] = useState(false);
    const [whitehc,setWhitehc] = useState(false);
    


    //day of life

     var dol1 = localStorage.getItem("Day of life 1")
     var dol2 = localStorage.getItem("Day of life 2")
     var dol3 = localStorage.getItem("Day of life 3")
     var dol4 = localStorage.getItem("Day of life 4")
     var dol5 = localStorage.getItem("Day of life 5")
     var dol6 = localStorage.getItem("Day of life 6")
     var dol7 = localStorage.getItem("Day of life 7")
     var dol8 = localStorage.getItem("Day of life 8")


     //To put into table ( FINAL ZSCORE VALUE) weight ! 

     

     var zw111 = localStorage.getItem("gzweight1")
     var zw11 = parseFloat(zw111)
     var zw1 = zw11.toFixed(1)
     localStorage.setItem("zw1", zw1)
     

     var zw222 = localStorage.getItem("gzweight2")
     var zw22 = parseFloat(zw222)
     var zw2 = zw22.toFixed(1)
     localStorage.setItem("zw2", zw2)

     var zw333 = localStorage.getItem("gzweight3")
     var zw33 = parseFloat(zw333)
     var zw3 = zw33.toFixed(1)
     localStorage.setItem("zw3", zw3)

     var zw444 = localStorage.getItem("gzweight4")
     var zw44 = parseFloat(zw444)
     var zw4 = zw44.toFixed(1)
     localStorage.setItem("zw4", zw4)

     var zw555 = localStorage.getItem("gzweight5")
     var zw55 = parseFloat(zw555)
     var zw5 = zw55.toFixed(1)
     localStorage.setItem("zw5", zw5)

     var zw666 = localStorage.getItem("gzweight6")
     var zw66 = parseFloat(zw666)
     var zw6 = zw66.toFixed(1)
     localStorage.setItem("zw6", zw6)

     var zw777 = localStorage.getItem("gzweight7")
     var zw77 = parseFloat(zw777)
     var zw7 = zw77.toFixed(1)
     localStorage.setItem("zw7", zw7)

     var zw888 = localStorage.getItem("gzweight8")
     var zw88 = parseFloat(zw888)
     var zw8 = zw88.toFixed(1)
     localStorage.setItem("zw8", zw8)

       //To put into table ( FINAL ZSCORE VALUE) length ! 
       var zl111 = localStorage.getItem("gzlength1")
       var zl11 = parseFloat(zl111)
       var zl1 = zl11.toFixed(1)
       //console.log(zl111,"kenak tok")
  
       var zl222 = localStorage.getItem("gzlength2")
       var zl22 = parseFloat(zl222)
       var zl2 = zl22.toFixed(1)
  
       var zl333 = localStorage.getItem("gzlength3")
       var zl33 = parseFloat(zl333)
       var zl3 = zl33.toFixed(1)
  
       var zl444 = localStorage.getItem("gzlength4")
       var zl44 = parseFloat(zl444)
       var zl4 = zl44.toFixed(1)
  
       var zl555 = localStorage.getItem("gzlength5")
       var zl55 = parseFloat(zl555)
       var zl5 = zl55.toFixed(1)
  
       var zl666 = localStorage.getItem("gzlength6")
       var zl66 = parseFloat(zl666)
       var zl6 = zl66.toFixed(1)
  
       var zl777 = localStorage.getItem("gzlength7")
       var zl77 = parseFloat(zl777)
       var zl7 = zl77.toFixed(1)
  
       var zl888 = localStorage.getItem("gzlength8")
       var zl88 = parseFloat(zl888)
       var zl8 = zl88.toFixed(1)

         //To put into table ( FINAL ZSCORE VALUE) head ! 
     var zh111 = localStorage.getItem("ghead1")
     var zh11 = parseFloat(zh111)
     var zh1 = zh11.toFixed(1)

     var zh222 = localStorage.getItem("ghead2")
     var zh22 = parseFloat(zh222)
     var zh2 = zh22.toFixed(1)

     var zh333 = localStorage.getItem("ghead3")
     var zh33 = parseFloat(zh333)
     var zh3 = zh33.toFixed(1)

     var zh444 = localStorage.getItem("ghead4")
     var zh44 = parseFloat(zh444)
     var zh4 = zh44.toFixed(1)

     var zh555 = localStorage.getItem("ghead5")
     var zh55 = parseFloat(zh555)
     var zh5 = zh55.toFixed(1)

     var zh666 = localStorage.getItem("ghead6")
     var zh66 = parseFloat(zh666)
     var zh6 = zh66.toFixed(1)

     var zh777 = localStorage.getItem("ghead7")
     var zh77 = parseFloat(zh777)
     var zh7 = zh77.toFixed(1)

     var zh888 = localStorage.getItem("ghead8")
     var zh88 = parseFloat(zh888)
     var zh8 = zh88.toFixed(1)



    /**
    * Z-SCORE NORMAL DISTRIBUTION (soft data)
    * 
    * var weight = cdf(zweight)
    * var hc = cdf(zhc)
    */
     
    
    //render this when @ hospital discharge ticked at growth.js
    //calculate changes in z score


    var gestweekC = localStorage.getItem("Gestational age week")
    var gestdayC = localStorage.getItem("Gestational age day")
    var ageDetailBirth = ((gestweekC - 22) * 7) + +gestdayC
    localStorage.setItem("ageDetailBirth", ageDetailBirth)

    var birthHeadC = localStorage.getItem("Birth head circumference")
    var birthWeightC = localStorage.getItem("Birth weight")
    var bweightC = birthWeightC * 1000

    var postweekC = localStorage.getItem("Postmenstrual age week")
    var postdayC = localStorage.getItem("Postmenstrual age day")
    var ageDetailDischarge = ((postweekC - 22) * 7) + +postdayC
    localStorage.setItem("ageDetailDischarge", ageDetailDischarge)

    var postHeadC = localStorage.getItem("Head circumference")
    var postWeightC = localStorage.getItem("current weight")
    var pWeightC = postWeightC * 1000
    


    //For Changes in Girl Birth Weight
    
    if(dataGW && dataGW.length > 0){
        dataGW.map((item) => {

            for (let i=0; i < dataGW.length; i ++){
                var items = dataGW;
                var gageB = items[i].ageD

                if(gender=="girl"){
                    if (ageDetailBirth == gageB){
                        if ( ageDetailBirth < 3.5){

                            console.log("No Z")
                        }

                        else if (ageDetailBirth > 196){

                            console.log("No Z")
                        }

                        else{

                            var gbweight = (((bweightC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(bweightC > 0){
                                localStorage.setItem("gbweight", gbweight)
                            }
                        }
                    }
                }
            }

    })}

    //For Changes in Girl Birth Head
    if(dataGH && dataGH.length > 0){
        dataGH.map((item) => {

            for (let i=0; i < dataGH.length; i ++){
                var items = dataGH;
                var gageB = items[i].ageD

                if(gender=="girl"){
                    if (ageDetailBirth == gageB){
                        if ( ageDetailBirth < 10.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailBirth > 196){

                            console.log("No Z")
                        }

                        else{

                            var gbhead = (((birthHeadC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(birthHeadC > 0){
                                localStorage.setItem("gbhead", gbhead)
                            }
                        }
                    }
                }
            }

    })}

    //For Changes in Boy Birth Weight
    if(dataBW && dataBW.length > 0){
        dataBW.map((item) => {

            for (let i=0; i < dataBW.length; i ++){
                var items = dataBW;
                var gageB = items[i].ageD

                if(gender=="boy"){
                    if (ageDetailBirth == gageB){
                        if ( ageDetailBirth < 3.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailBirth > 196){

                            console.log("No Z")
                        }

                        else{

                            var gbweight = (((bweightC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(bweightC > 0){
                                localStorage.setItem("gbweight", gbweight)
                            }
                        }
                    }
                }
            }

    })}


    //For Changes in Boy Birth Head
    if(dataBH && dataBH.length > 0){
        dataBH.map((item) => {

            for (let i=0; i < dataBH.length; i ++){
                var items = dataBH;
                var gageB = items[i].ageD

                if(gender=="boy"){
                    if (ageDetailBirth == gageB){
                        if ( ageDetailBirth < 10.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailBirth > 196){

                            console.log("No Z")
                        }

                        else{

                            var gbhead = (((birthHeadC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(birthHeadC > 0){
                                localStorage.setItem("gbhead", gbhead)
                            }
                        }
                    }
                }
            }

    })}



     //For Changes in Girl Discharge Weight
     if(dataGW && dataGW.length > 0){
        dataGW.map((item) => {

            for (let i=0; i < dataGW.length; i ++){
                var items = dataGW;
                var gageB = items[i].ageD

                if(gender=="girl"){
                    if (ageDetailDischarge == gageB){
                        if ( ageDetailDischarge < 3.5){

                            console.log("No Z")
                        }

                        else if (ageDetailDischarge > 196){

                            console.log("No Z")
                        }

                        else{

                            var gpweight = (((pWeightC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(postWeightC > 0){
                                localStorage.setItem("gpweight", gpweight)
                            }
                        }
                    }
                }
            }

    })}

    //For Changes in Girl Discharge Head
    if(dataGH && dataGH.length > 0){
        dataGH.map((item) => {

            for (let i=0; i < dataGH.length; i ++){
                var items = dataGH;
                var gageB = items[i].ageD

                if(gender=="girl"){
                    if (ageDetailDischarge == gageB){
                        if ( ageDetailDischarge < 10.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailDischarge > 196){

                            console.log("No Z")
                        }

                        else{

                            var gphead = (((postHeadC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(postHeadC > 0){
                                localStorage.setItem("gphead", gphead)
                            }
                        }
                    }
                }
            }

    })}

    //For Changes in Boy Discharge Weight
    if(dataBW && dataBW.length > 0){
        dataBW.map((item) => {

            for (let i=0; i < dataBW.length; i ++){
                var items = dataBW;
                var gageB = items[i].ageD

                if(gender=="boy"){
                    if (ageDetailDischarge == gageB){
                        if ( ageDetailDischarge < 3.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailDischarge > 196){

                            console.log("No Z")
                        }

                        else{

                            var gpweight = (((pWeightC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(postWeightC > 0){
                                localStorage.setItem("gpweight", gpweight)
                            }
                        }
                    }
                }
            }

    })}


    //For Changes in Boy Discharge Head
    if(dataBH && dataBH.length > 0){
        dataBH.map((item) => {

            for (let i=0; i < dataBH.length; i ++){
                var items = dataBH;
                var gageB = items[i].ageD

                if(gender=="boy"){
                    if (ageDetailDischarge == gageB){
                        if ( ageDetailDischarge < 10.5){
                            
                            console.log("No Z")
                        }

                        else if (ageDetailDischarge > 196){

                            console.log("No Z")
                        }

                        else{

                            var gphead = (((birthHeadC / items[i].fields.M) ** (items[i].fields.L) - 1) / (items[i].fields.L * items[i].fields.S))
                            if(birthHeadC > 0){
                                localStorage.setItem("gphead", gphead)
                            }
                        }
                    }
                }
            }

    })}


    var bweight11 = localStorage.getItem("gbweight")
    var bweight1 = parseFloat(bweight11)
    var bweight = bweight1.toFixed(1)
    localStorage.setItem("bweight", bweight)


    var bbhead11 = localStorage.getItem("gbhead")
    var bbhead1 = parseFloat(bbhead11)
    var bbhead = bbhead1.toFixed(1)
    localStorage.setItem("bbhead", bbhead)

    var pweight11 = localStorage.getItem("gpweight")
    var pweight1 = parseFloat(pweight11)
    var pweight =  pweight1.toFixed(1)
    localStorage.setItem("pweight", pweight)


    var phead11 = localStorage.getItem("gphead")
    var phead1 = parseFloat(phead11)
    var phead = phead1.toFixed(1)
    localStorage.setItem("phead", phead)


    //change in Z bubble => p(discharge) - b(birth)
    var weight = (+pweight - +bweight).toFixed(1); 
    localStorage.setItem("percentage weight", weight)
    var hc = (+phead - +bbhead).toFixed(1); 
    localStorage.setItem("percentage hc", hc)


    async function handleBubbleW() {

    
      if ( weight >= -(1.0)) {
          setGreen(true)
          setOrange(false)
          setRed(false)
          setWhite(false)
      }  


      else if ( weight < -(2.0)) {
        setGreen(false)
        setOrange(false)
        setRed(true)
        setWhite(false)
      }

      else if ( weight >= -(2.0) || weight < -(1.0) ) { //in between value
          
          setGreen(false)
          setOrange(true)
          setRed(false)
          setWhite(false)
      }

      else {

        setGreen(false)
          setOrange(false)
          setRed(false)
          setWhite(true)

      }


    }

    //for HC

    async function handleBubbleHC () {
        if (hc >= -(1.0)){
            setGreenhc(true)
            setOrangehc(false)
            setRedhc(false)
            setWhitehc(false)
      
      
        }

        else if (hc < -(2.0)){
            setGreenhc(false)
            setOrangehc(false)
            setRedhc(true)
            setWhitehc(false)
       
        }

        else if ( hc >= -(2.0) || hc < -(1.0)) {
          
            setGreenhc(false)
            setOrangehc(true)
            setRedhc(false)
            setWhitehc(false)

        }

        else{
            setGreenhc(false)
            setOrangehc(false)
            setRedhc(false)
            setWhitehc(true)
        }

    }


    useEffect(() => {
        
        getGWR()
        getGLR()
        getGHR()
        getBWR()
        getBLR()
        getBHR()
        handleBubbleW()
        handleBubbleHC()

        const interval = setInterval(() => {
           
            getGWR()
            getGLR()
            getGHR()
            getBWR()
            getBLR()
            getBHR()
            handleBubbleW()
            handleBubbleHC()
          }, 60000); //60 seconds => color needs to tap after 1min
          return () => clearInterval(interval);
    }, [])


    return (
        <div className="row">
        <div className="col-md-12">
        <div className="growth__page1">
        <Header/>
        <div className="zscore__content">
        <form>
            <div className = "zscore__contentHeader">
                <p><strong>Days of Life</strong></p>
            </div>
            <Table className = "days__of__life__table" striped bordered hover size="sm" responsive="sm" > 
                <thead>
                    <tr>
                        <th>
                            Days
                        </th>
                        <th>
                            {dol1}
                        </th>
                        <th>
                        {dol2}
                        </th>
                        <th>
                        {dol3}
                        </th>
                        <th>
                        {dol4}
                        </th>
                        <th>
                        {dol5}
                        </th>
                        <th>
                        {dol6}
                        </th>
                        <th>
                        {dol7}
                        </th>
                        <th>
                        {dol8}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Icon icon={scaleUnbalance} />
                        </td>
                        <td>{zw1  == "NaN" ? "null" : zw1}</td>
                        <td>{zw2  == "NaN" ? "null" : zw2}</td>
                        <td>{zw3  == "NaN" ? "null" : zw3}</td>
                        <td>{zw4  == "NaN" ? "null" : zw4}</td>
                        <td>{zw5 == "NaN" ? "null" : zw5}</td>
                        <td>{zw6  == "NaN" ? "null" : zw6}</td>
                        <td>{zw7  == "NaN" ? "null" : zw7}</td>
                        <td>{zw8  == "NaN" ? "null" : zw8}</td>
                        
                    </tr>
                    <tr>
                        <td>
                        <Icon icon = {babyIcon}/> 
                        </td>
                        <td>{zl1  == "NaN" ? "null" : zl1}</td>
                        <td>{zl2 == "NaN" ? "null" : zl2}</td>
                        <td>{zl3 == "NaN" ? "null" : zl3}</td>
                        <td>{zl4 == "NaN" ? "null" : zl4}</td>
                        <td>{zl5  == "NaN" ? "null" : zl5}</td>
                        <td>{zl6 == "NaN" ? "null" : zl6}</td>
                        <td>{zl7 == "NaN" ? "null" : zl7}</td>
                        <td>{zl8 == "NaN" ? "null" : zl8}</td>
                        
                    </tr>
                    <tr>
                        <td>
                            <Icon icon={iNeurology} />
                        </td>
                        <td>{zh1 == "NaN" ? "null" : zh1}</td>
                        <td>{zh2 == "NaN" ? "null" : zh2}</td>
                        <td>{zh3 == "NaN" ? "null" : zh3}</td>
                        <td>{zh4 == "NaN" ? "null" : zh4}</td>
                        <td>{zh5 == "NaN" ? "null" : zh5}</td>
                        <td>{zh6 == "NaN" ? "null" : zh6}</td>
                        <td>{zh7 == "NaN" ? "null" : zh7}</td>
                        <td>{zh8 == "NaN" ? "null" : zh8}</td>
                    </tr>
                </tbody>
            </Table>
            <div className = "zscore__contentHeader">
                <div className = "underline__header">
                <strong>Changes in Z-scores from Birth to Discharge</strong>
                </div>
            </div>

            <div className = "smallnote__pushbottom">
                <h2>**Tap the circle to see the exact color level</h2>
            </div>

            <div className = "weight__pushbottom">
            <p>
                <strong>Weight</strong> 
                <span>
                <Icon className ="weight__logo" icon={scaleUnbalance} />
                </span>
                <div className = "to__theleft">
                <span onClick =  {handleBubbleW} value = {weight}> {white && <WhiteW/>} </span>
                <span onClick =  {handleBubbleW} value = {weight}> {green && <GreenW/>} </span>
                 <span onClick =  {handleBubbleW} value = {weight}> {orange && <OrangeW/>} </span>
                 <span onClick =  {handleBubbleW} value = {weight}> {red && <RedW/>} </span>
               </div>
            </p>
            </div>
                
            <div className = "head__pushtop">
                <p>
                <strong>Head Circumference</strong>
                <span>
                <Icon className ="headcir__logo" icon={iNeurology}  />
                </span>
                <div className = "to__theleft">
                <span onClick =  {handleBubbleHC} value = {hc}> {whitehc && <WhiteHC/>} </span>
                <span onClick =  {handleBubbleHC} value = {hc}> {greenhc && <GreenHC/>} </span>
                 <span onClick =  {handleBubbleHC} value = {hc}> {orangehc && <OrangeHC/>} </span>
                 <span onClick =  {handleBubbleHC} value = {hc}> {redhc && <RedHC/>} </span>
                 </div>
                </p>  
            </div>

            <div className = "zscore__contentHeader">
                <div className = "smallnote__pushbottom">
                Not to lose more than -1 SD in weight and head circumference from birth to discharge.
                </div>
            </div>


            
            <div className = "zscore__indicator">
                <h3>Indicator</h3>
            <div className = "goto__left">
            <img src={process.env.PUBLIC_URL + "assets/indicator.png"}
                width = "270"
                height = "100"
                alt = "indicator" />
            </div>
           
            <button className = "goto__homepage" onClick = {home} >
            <Icon icon={homeIcon} /> Homepage
            </button>
            </div>
            </form>
            </div>
            </div>
        </div>
        </div>
    )
}

export default Scores
